let Messages = {
    SET_MESSAGES: 'SET_MESSAGES',
    SET_VIEWED_MESSAGE: 'SET_VIEWED_MESSAGE',
    SET_SPORT_MESSAGE: 'SET_SPORT_MESSAGE',

    ZERO_GENERATED_LINEUPS_MESSAGE:
        'Not enough players selected to fit a team within the salary cap. Please make sure you have enough players in your pool to create a valid lineup.',
    FLEX_TAB_IN_EXPOSURE_BOX_TOOLTIP_SUBJECT:
        'Players exposures under the FLEX tab show just what is in the FLEX position in lineups.',
    CSV_PLAYERS_NOT_MATCHED_MESSAGE:
        'Some players from your CSV haven’t been found in the Player Pool. Please match these players manually.',
};

export default Messages;
